import { gettext } from '@eventbrite/i18n';
import React, { FunctionComponent } from 'react';

export interface RemainingTicketsProps {
    quantityRemaining: number;
}

export const RemainingTickets: FunctionComponent<RemainingTicketsProps> = ({
    quantityRemaining,
}) => (
    <span
        className="ticket-status eds-text-bm eds-text-color--ui-600 eds-l-pad-right-2"
        data-spec="remaining-tickets"
    >
        {gettext('%(quantityRemaining)s REMAINING', {
            quantityRemaining,
        })}
    </span>
);

export default RemainingTickets;
